// extracted by mini-css-extract-plugin
export var banner = "_ob-0";
export var settingRow = "_ob-2";
export var titleIcon = "_ob-1";